export const Colors = [
    { value: 'yellow lighten-4' },
    { value: 'light-green lighten-4' },
    { value: 'orange lighten-4' },
    { value: 'deep-purple lighten-4' },
    { value: 'amber lighten-4' },
    { value: 'pink lighten-4' },
    { value: 'deep-orange lighten-4' },
    { value: 'teal lighten-4' },
    { value: 'light-blue lighten-4' },
    { value: 'red lighten-4' }
]



// WEBPACK FOOTER //
// ./src/config/enum/Colors.js